import { EmployeeDTO } from '@Models/model.types.ts';

export type OverviewDTO = {
    id: number;
    datePeriod: string;
    displayName: string;
    comment: string;
    voucherDate: string;
    paymentDate: string;
    voucherNumberAsString: string;
    ameldingWageId: number;
    ameldingStatus: AmeldingOverviewStatus;
    ameldingDueDate: string;
    completedLogId: number;
    wagePaymentTransactionId: number;
    wagePeriodTransactionId: number;
    wagePeriodTransactionVoucherNumber: string;
    reversedVoucherDisplayName: string;
    reversedBy: string;
    voucherId?: number;
    eniBasis: number;
    approvedBy: EmployeeDTO;
    approvalDate: Date;
};

export enum AmeldingOverviewStatus {
    // GRAY STATUS -----------------
    NEUTRAL = 'NEUTRAL',
    // ---------------------------------

    // GREEN STATUS ----------------
    SUCCESS = 'SUCCESS',
    // ---------------------------------

    // YELLOW STATUS --------------
    WARNING = 'WARNING',
    WARNING_GUIDELINE = 'WARNING_GUIDELINE',
    // ---------------------------------

    // RED STATUS -------------------
    ERROR = 'ERROR',
    ERROR_IMMEDIATELY = 'ERROR_IMMEDIATELY',
    ERROR_REJECTED = 'ERROR_REJECTED',
    // ---------------------------------
}
